module.exports = __webpack_public_path__ + "static/media/favicon.ae6bbf11.png";